<template>
  <div class="exam-post">
    <ul class="changestateul">
      <li
        v-for="(tab, index) in tabs"
        @click="toggle(index, tab.view)"
        :class="{ active: active == index }"
        :key="index"
      >
        {{ tab.type }}
      </li>
    </ul>
    <div class="clearfix"></div>
    <!--:is实现多个组件实现同一个挂载点-->
    <component :is="currentView"></component>
  </div>
</template>

<script>
import Apply from "./feedback/apply.vue";
import Record from "./feedback/record.vue";
export default {
  name: "ExamPost",
  components: {
    Apply,
    Record
  },
  data: function() {
    return {
      active: 0,
      currentView: "Apply",
      tabs: [
        {
          type: "意见反馈",
          view: "Apply"
        },
        {
          type: "反馈记录",
          view: "Record"
        }
      ],
      arrs: []
    };
  },
  created() {},
  methods: {
    toggle(i, v) {
      this.active = i;
      this.currentView = v;
    }
  }
};
</script>

<style lang="stylus" scoped>
@import '~styles/varibles.styl';
@import '~styles/mixins.styl';

.exam-post {
  background: $bgcontent;
  min-height: 500px;
  padding: 28px;

  .changestateul li {
    float: left;
    margin-right: 30px;
    width: 108px;
    height: 32px;
    line-height: 32px;
    background: #ffffff;
    color: #999999;
    cursor: pointer;
    text-align: center;
    border-radius: 3px;

    &.active {
      background: $bgColor;
      color: #fff;
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/pages/PersonalCenters/components/feedBack.vue